import React from 'react';
import AreaDetailPage from './AreaDetailPage';
import { casinoAreas } from '../data/mapData';

function CasinoArea({ area }) {
  const config = casinoAreas[area] || casinoAreas['casino-floor'];
  return <AreaDetailPage config={config} sectionHeader="Casino" />;
}

export default CasinoArea;
